var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"con_item1"},[_c('ul',[_c('li',{staticClass:"top_back1",style:({
        backgroundImage:
          'url(' + require('@/assets/images/wangge_back.png') + ')',
        backgroundRepeat: _vm.repeat,
      })},[_c('div',{staticClass:"textBox li_item"},[_c('div',[_vm._v(_vm._s(_vm.$t('lang.stat.network')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.info.netHash))])])]),_vm._v(" "),_c('li',{staticClass:"top_back2",style:({
        backgroundImage:
          'url(' + require('@/assets/images/star_back.png') + ')',
        backgroundRepeat: _vm.repeat,
      })},[_c('div',{staticClass:"textBox li_item"},[_c('div',[_vm._v(_vm._s(_vm.$t('lang.stat.difficulty')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.info.difficulty))])])]),_vm._v(" "),_c('li',{staticClass:"li_logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":""}})]),_vm._v(" "),_c('li',{staticClass:"top_back3",style:({
        backgroundImage:
          'url(' + require('@/assets/images/all_back.png') + ')',
        backgroundRepeat: _vm.repeat,
      })},[_c('div',{staticClass:"textBox li_item"},[_c('div',[_vm._v(_vm._s(_vm.$t('lang.stat.supply')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.info.supply))])])]),_vm._v(" "),_c('li',{staticClass:"top_back4",style:({
        backgroundImage:
          'url(' + require('@/assets/images/jiedian_back.png') + ')',
        backgroundRepeat: _vm.repeat,
      })},[_c('div',{staticClass:"textBox li_item"},[_c('div',[_vm._v(_vm._s(_vm.$t('lang.stat.tickey')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.info.nodeCount))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528ced14","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stat.vue
// module id = null
// module chunks = 